// React props only. A report's row arrays and callback functions must keep
// their identity; small scalar option records may be recreated by the shell.
// Context updates and a table's own state still render normally.
export function equalReportProps<T extends object>(before: T, after: T): boolean {
  const equal = (a: unknown, b: unknown): boolean => {
    if (Object.is(a, b)) return true;
    if (!a || !b || Object.getPrototypeOf(a) !== Object.prototype || Object.getPrototypeOf(b) !== Object.prototype) return false;
    const left = a as Record<string, unknown>, right = b as Record<string, unknown>;
    const keys = Object.keys(left);
    return keys.length === Object.keys(right).length && keys.every(key => Object.hasOwn(right, key) && Object.is(left[key], right[key]));
  };
  const keys = Object.keys(before) as (keyof T)[];
  return keys.length === Object.keys(after).length && keys.every(key => Object.hasOwn(after, key) && equal(before[key], after[key]));
}
